import React from 'react';
import DailyQuestItem from './DailyQuestItem';
import { MissionStep, UserMissionProgress } from '@/types/missions';

interface DailyQuestsListProps {
  steps: MissionStep[];
  progress: UserMissionProgress[];
  currentDay: number;
  onValidateTask: () => Promise<void>;
  validating: boolean;
}

const DailyQuestsList: React.FC<DailyQuestsListProps> = ({
  steps,
  progress,
  onValidateTask,
  validating,
}) => {
  const getQuestStatus = (dayNumber: number): 'completed' | 'available' => {
    const dayProgress = progress.find((p) => p.day_number === dayNumber);
    if (!dayProgress) return 'available';
    
    if (dayProgress.status === 'completed') return 'completed';
    return 'available';
  };

  const getIconForDay = (dayNumber: number) => {
    const icons = ['❤️', '⭐', '🎯', '⚡', '🏆', '📈', '📝', '✨'];
    return icons[(dayNumber - 1) % icons.length];
  };

  // Sort steps: incomplete first, completed at the end
  const sortedSteps = [...steps].sort((a, b) => {
    const statusA = getQuestStatus(a.day_number);
    const statusB = getQuestStatus(b.day_number);
    
    // Completed items go to the end
    if (statusA === 'completed' && statusB !== 'completed') return 1;
    if (statusA !== 'completed' && statusB === 'completed') return -1;
    
    // Keep original order for same status
    return a.day_number - b.day_number;
  });

  return (
    <div>
      {/* Header */}
      <div className="mb-4">
        <h2 className="text-sm font-medium text-white">
          Tarefas da Jornada
        </h2>
      </div>

      {/* Lista de quests */}
      <div className="space-y-2">
        {sortedSteps.map((step) => {
          const status = getQuestStatus(step.day_number);
          const icon = getIconForDay(step.day_number);
          
          // Progresso: 0 ou 1 (completo ou não)
          const current = status === 'completed' ? 1 : 0;
          const total = 1;

          return (
            <DailyQuestItem
              key={step.id}
              icon={icon}
              title={step.title}
              description={step.description}
              current={current}
              total={total}
              status={status}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DailyQuestsList;
